/**
 * Shared form options for signup and company info forms
 */

export interface SelectOption {
  value: string;
  label: string;
}

// Standard NAICS industry classifications
// value = NAICS code + official name (saved to database)
// label = simplified version (displayed in UI)
export const INDUSTRY_OPTIONS: SelectOption[] = [
  { value: '', label: 'Select an industry (optional)' },
  { value: '11 - Agriculture, Forestry, Fishing and Hunting', label: 'Agriculture & Forestry' },
  { value: '21 - Mining, Quarrying, and Oil and Gas Extraction', label: 'Mining & Oil/Gas' },
  { value: '22 - Utilities', label: 'Utilities' },
  { value: '23 - Construction', label: 'Construction' },
  { value: '31-33 - Manufacturing', label: 'Manufacturing' },
  { value: '42 - Wholesale Trade', label: 'Wholesale Trade' },
  { value: '44-45 - Retail Trade', label: 'Retail Trade' },
  { value: '48-49 - Transportation and Warehousing', label: 'Transportation & Warehousing' },
  { value: '51 - Information', label: 'Information & Technology' },
  { value: '52 - Finance and Insurance', label: 'Finance & Insurance' },
  { value: '53 - Real Estate and Rental and Leasing', label: 'Real Estate' },
  { value: '54 - Professional, Scientific, and Technical Services', label: 'Professional Services' },
  { value: '55 - Management of Companies and Enterprises', label: 'Management & Consulting' },
  { value: '56 - Administrative and Support and Waste Management and Remediation Services', label: 'Administrative & Support Services' },
  { value: '61 - Educational Services', label: 'Education' },
  { value: '62 - Health Care and Social Assistance', label: 'Healthcare & Social Services' },
  { value: '71 - Arts, Entertainment, and Recreation', label: 'Arts & Entertainment' },
  { value: '72 - Accommodation and Food Services', label: 'Hospitality & Food Services' },
  { value: '81 - Other Services (except Public Administration)', label: 'Other Services' },
  { value: '92 - Public Administration', label: 'Public Administration' },
];

// US States for timezone derivation
export const US_STATE_OPTIONS: SelectOption[] = [
  { value: '', label: 'Select State' },
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

// Country options (excluding EU countries due to GDPR and China)
export const COUNTRY_OPTIONS: SelectOption[] = [
  { value: '', label: 'Select Country' },
  { value: 'AU', label: 'Australia' },
  { value: 'CA', label: 'Canada' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'JP', label: 'Japan' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MX', label: 'Mexico' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'PH', label: 'Philippines' },
  { value: 'SG', label: 'Singapore' },
  { value: 'KR', label: 'South Korea' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TH', label: 'Thailand' },
  { value: 'US', label: 'United States' },
  { value: 'VN', label: 'Vietnam' },
];
